export enum RgbSubThemeIds {
  default = 'default',
  rgb = 'rgb',
  glowingPrimary = 'glowing-primary',
  glowingSecondary = 'glowing-secondary',
  glowingTertiary = 'glowing-tertiary',
  glowingDuo = 'glowing-duo',
}

export const RgbSubThemeOptions = [
  { value: RgbSubThemeIds.default, label: 'Default' },
  { value: RgbSubThemeIds.rgb, label: 'RGB' },
];
